import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import EditReview from './EditProductReview';
import { Edit } from '@mui/icons-material';

const ProductReviews = ({ product, fetchProduct, setSnackbarOpen, setMessage }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Card>
        <CardHeader
          title="User reviews"
          action={
            product.reviews.length > 0 && product.reviews.length <= 3 && (
              <IconButton onClick={() => setOpen(true)}>
                <Edit />
              </IconButton>
            )
          }
        />
        <CardContent>
          {product?.reviews?.length > 0 ? (
            product.reviews.slice(0, 3).map((review, index) => (
              <div key={index}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between">
                  <Box
                    marginLeft={2}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%">
                    <Typography
                      variant="subtitle1"
                      sx={{ fontSize: '16px', marginBottom: '4px' }}>
                      {`${review.user.first_name} ${review.user.last_name}`}
                      <Typography
                        variant="subtitle2"
                        sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
                        {`${review.user.email}`}
                      </Typography>
                    </Typography>
                    <Box display="flex" alignItems="center" marginRight={2}>
                      {review.type === 'buy' ? (
                        <ThumbUpIcon sx={{ color: 'success.main' }} />
                      ) : review.type === 'skip' ? (
                        <ThumbDownIcon sx={{ color: 'error.main' }} />
                      ) : null}
                    </Box>
                  </Box>
                </Box>
                <Typography marginLeft={2} variant="body1">
                  {review.updated_review}
                </Typography>
                {index < product.reviews.length - 1 && (
                  <Divider
                    sx={{ my: 1, backgroundColor: 'rgba(0, 0, 0, 0.2)' }}
                  />
                )}
              </div>
            ))
          ) : (
            <Typography
              sx={{ textAlign: 'center' }}
              variant="caption"
              component="p">
              No user reviews available
            </Typography>
          )}
          {product.reviews.length > 3 && (
            <Button
              variant="text"
              onClick={() => setOpen(true)}
              sx={{
                width: '100%',
                color: 'primary.main',
              }}>
              Show all
            </Button>
          )}
        </CardContent>
      </Card>
      <EditReview
        open={open}
        setOpen={setOpen}
        reviews={product.reviews}
        productId={product.id}
        fetchProduct={fetchProduct}
        setMessage={setMessage}
        setSnackbarOpen={setSnackbarOpen}
      />
    </>
  );
};

export default ProductReviews;
